export default {
  loginAs: 'You are logged in as  ',
};
